import { REAR, FRONT, CAMERA } from './values';
import { prepareSortedOptions } from '../../prepareOptions';

export default prepareSortedOptions([
  {
    value: REAR,
    label: __('carDetails.parkingAssistanceType.rear'),
  },
  {
    value: FRONT,
    label: __('carDetails.parkingAssistanceType.frontAndRear'),
  },
  {
    value: CAMERA,
    label: __('carDetails.parkingAssistanceType.rearCamera'),
  },
]);
